import React, { useState } from "react";
import Header from "../../sharedScreens/Header";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import { MuiInput } from "../../components/basicComponent/MuiInput";
import MuiButton from "../../components/basicComponent/MuiButton";
import MuiDatePicker from "../../components/basicComponent/MuiDatePicker";
import MuiSearchSelect from "../../components/basicComponent/MuiSearchSelect";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Switch from "@mui/material/Switch";

const ViewSupplierCommission = () => {
  const [active, setActive] = useState<Boolean>(false);
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header mb-1 managebookingg">
              <h3 className="card-title titlecolorr">
                View Supplier Commission
              </h3>
              <button
                className="fliter-btn"
                onClick={() => {
                  setActive(!active);
                }}
              >
                <span>Create Supplier Commission</span>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    {active && (
                      <div className="row mt-4">
                        <div className="col-md-4">
                          <MuiSearchSelect
                            label="Airline "
                            onChange={function (date: string): void {
                              throw new Error("Function not implemented.");
                            }}
                            placeholder={""}
                            options={[]}
                            value={""}
                          />
                        </div>

                        <div className="col-md-2 mt-2">
                          <div className=" w-full">
                            <MuiButton
                              className="main-btn get-btn"
                              variant="contained"
                              size="large"
                              type="submit"
                              label={"Get"}
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {!active && (
                      <>
                        <div className="row mt-4">
                          <div className="col-md-4">
                            <MuiSearchSelect
                              label="CRS "
                              onChange={function (date: string): void {
                                throw new Error("Function not implemented.");
                              }}
                              placeholder={"CRS"}
                              options={[]}
                              value={""}
                            />
                          </div>
                        </div>

                        <div className="row mt-4">
                          <div className="card card-grid min-w-full">
                            <div className="card-body">
                              <div
                                data-datatable="true"
                                data-datatable-page-size={20}
                                className="datatable-initialized"
                              >
                                <div className="scrollable-x-auto">
                                  <div
                                    className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                                    data-datatable-spinner="true"
                                    style={{ display: "none" }}
                                  >
                                    <div className="flex items-center gap-2 px-4 py-2 font-medium leading-none text-2sm border border-gray-200 shadow-default rounded-md text-gray-500 bg-light">
                                      <svg
                                        className="animate-spin -ml-1 h-5 w-5 text-gray-600"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                      >
                                        <circle
                                          className="opacity-25"
                                          cx={12}
                                          cy={12}
                                          r={10}
                                          stroke="currentColor"
                                          strokeWidth={3}
                                        />
                                        <path
                                          className="opacity-75"
                                          fill="currentColor"
                                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                        />
                                      </svg>
                                      Loading...
                                    </div>
                                  </div>
                                  <table
                                    className="table table-border"
                                    data-datatable-table="true"
                                  >
                                    <thead>
                                      <tr>
                                        <th className="min-w-[140px]">Type</th>
                                        <th className="min-w-[150px]">
                                          <span className="sort">
                                            <span className="sort-label text-gray-700 font-normal">
                                              Airport
                                            </span>
                                            <span className="sort-icon"></span>
                                          </span>
                                        </th>
                                        <th className="min-w-[140px]">
                                          <span className="sort">
                                            <span className="sort-label text-gray-700 font-normal">
                                              Category
                                            </span>
                                            <span className="sort-icon"></span>
                                          </span>
                                        </th>
                                        <th className="min-w-[170px]">
                                          <span className="sort">
                                            <span className="sort-label text-gray-700 font-normal">
                                              Airline / Supplier id
                                            </span>
                                            <span className="sort-icon"></span>
                                          </span>
                                        </th>
                                        <th className="min-w-[150px]">
                                          <span className="sort">
                                            <span className="sort-label text-gray-700 font-normal">
                                              Cabin
                                            </span>
                                            <span className="sort-icon"></span>
                                          </span>
                                        </th>
                                        <th className="min-w-[150px]">
                                          <span className="sort">
                                            <span className="sort-label text-gray-700 font-normal">
                                              Flat Type
                                            </span>
                                            <span className="sort-icon"></span>
                                          </span>
                                        </th>

                                        <th className="min-w-[150px]">
                                          <span className="sort">
                                            <span className="sort-label text-gray-700 font-normal">
                                              Fare Type
                                            </span>
                                            <span className="sort-icon"></span>
                                          </span>
                                        </th>
                                        <th className="min-w-[150px]">
                                          <span className="sort">
                                            <span className="sort-label text-gray-700 font-normal">
                                              (%) Type
                                            </span>
                                            <span className="sort-icon"></span>
                                          </span>
                                        </th>
                                        <th className="min-w-[170px]">
                                          <span className="sort">
                                            <span className="sort-label text-gray-700 font-normal">
                                              Cash Income Type
                                            </span>
                                            <span className="sort-icon"></span>
                                          </span>
                                        </th>
                                        <th className="min-w-[170px]">
                                          <span className="sort">
                                            <span className="sort-label text-gray-700 font-normal">
                                              Cash Income
                                            </span>
                                            <span className="sort-icon"></span>
                                          </span>
                                        </th>
                                        <th className="w-[170px]">
                                          <span className="sort">
                                            <span className="sort-label text-gray-700 font-normal">
                                              Monthly
                                            </span>
                                            <span className="sort-icon"></span>
                                          </span>
                                        </th>
                                        <th className="w-[170px]">
                                          <span className="sort">
                                            <span className="sort-label text-gray-700 font-normal">
                                              Quartly
                                            </span>
                                            <span className="sort-icon"></span>
                                          </span>
                                        </th>
                                        <th className="min-w-[200px]">
                                          <span className="sort">
                                            <span className="sort-label text-gray-700 font-normal">
                                              Half Yearly
                                            </span>
                                            <span className="sort-icon"></span>
                                          </span>
                                        </th>
                                        <th className="min-w-[170px]">
                                          <span className="sort">
                                            <span className="sort-label text-gray-700 font-normal">
                                              Yearly
                                            </span>
                                            <span className="sort-icon"></span>
                                          </span>
                                        </th>
                                        <th className="min-w-[170px]">
                                          <span className="sort">
                                            <span className="sort-label text-gray-700 font-normal">
                                              Segment Fee
                                            </span>
                                            <span className="sort-icon"></span>
                                          </span>
                                        </th>
                                        <th className="min-w-[170px]">
                                          <span className="sort">
                                            <span className="sort-label text-gray-700 font-normal">
                                              Cash Back
                                            </span>
                                            <span className="sort-icon"></span>
                                          </span>
                                        </th>
                                        <th className="min-w-[170px]">
                                          <span className="sort">
                                            <span className="sort-label text-gray-700 font-normal">
                                              W.e.f. Date
                                            </span>
                                            <span className="sort-icon"></span>
                                          </span>
                                        </th>
                                        <th className="min-w-[170px]">
                                          <span className="sort">
                                            <span className="sort-label text-gray-700 font-normal">
                                              Valid Upto
                                            </span>
                                            <span className="sort-icon"></span>
                                          </span>
                                        </th>
                                        <th className="min-w-[170px]">
                                          <span className="sort">
                                            <span className="sort-label text-gray-700 font-normal">
                                              Valid For
                                            </span>
                                            <span className="sort-icon"></span>
                                          </span>
                                        </th>
                                        <th className="min-w-[170px]">
                                          <span className="sort">
                                            <span className="sort-label text-gray-700 font-normal">
                                              More
                                            </span>
                                            <span className="sort-icon"></span>
                                          </span>
                                        </th>
                                        <th className="min-w-[170px]">
                                          <span className="sort">
                                            <span className="sort-label text-gray-700 font-normal">
                                              Click
                                            </span>
                                            <span className="sort-icon"></span>
                                          </span>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>
                                          <MuiSearchSelect
                                            placeholder={"commission"}
                                            label="commission"
                                            options={[]}
                                            onChange={function (
                                              value: string,
                                              id: string,
                                              data: any
                                            ): void {
                                              throw new Error(
                                                "Function not implemented."
                                              );
                                            }}
                                            value={""}
                                          />
                                        </td>
                                        <td className="text-gray-800 font-normal">
                                          <MuiSearchSelect
                                            placeholder={"commission"}
                                            label="commission"
                                            options={[]}
                                            onChange={function (
                                              value: string,
                                              id: string,
                                              data: any
                                            ): void {
                                              throw new Error(
                                                "Function not implemented."
                                              );
                                            }}
                                            value={""}
                                          />
                                        </td>
                                        <td>
                                          <MuiSearchSelect
                                            placeholder={"commission"}
                                            label="commission"
                                            options={[]}
                                            onChange={function (
                                              value: string,
                                              id: string,
                                              data: any
                                            ): void {
                                              throw new Error(
                                                "Function not implemented."
                                              );
                                            }}
                                            value={""}
                                          />
                                        </td>
                                        <td className="text-gray-800 font-normal">
                                          <MuiSearchSelect
                                            placeholder={"commission"}
                                            label="commission"
                                            options={[]}
                                            onChange={function (
                                              value: string,
                                              id: string,
                                              data: any
                                            ): void {
                                              throw new Error(
                                                "Function not implemented."
                                              );
                                            }}
                                            value={""}
                                          />
                                        </td>
                                        <td className="text-gray-800 font-normal">
                                          <MuiSearchSelect
                                            placeholder={"commission"}
                                            label="commission"
                                            options={[]}
                                            onChange={function (
                                              value: string,
                                              id: string,
                                              data: any
                                            ): void {
                                              throw new Error(
                                                "Function not implemented."
                                              );
                                            }}
                                            value={""}
                                          />
                                        </td>
                                        <td className="text-gray-800 font-normal">
                                          <MuiSearchSelect
                                            placeholder={"commission"}
                                            label="commission"
                                            options={[]}
                                            onChange={function (
                                              value: string,
                                              id: string,
                                              data: any
                                            ): void {
                                              throw new Error(
                                                "Function not implemented."
                                              );
                                            }}
                                            value={""}
                                          />
                                        </td>
                                        <td className="text-center">
                                          {" "}
                                          <MuiSearchSelect
                                            placeholder={"commission"}
                                            label="commission"
                                            options={[]}
                                            onChange={function (
                                              value: string,
                                              id: string,
                                              data: any
                                            ): void {
                                              throw new Error(
                                                "Function not implemented."
                                              );
                                            }}
                                            value={""}
                                          />
                                        </td>
                                        <td className="text-gray-800 font-normal">
                                          <MuiSearchSelect
                                            placeholder={"commission"}
                                            label="commission"
                                            options={[]}
                                            onChange={function (
                                              value: string,
                                              id: string,
                                              data: any
                                            ): void {
                                              throw new Error(
                                                "Function not implemented."
                                              );
                                            }}
                                            value={""}
                                          />
                                        </td>
                                        <td className="text-gray-800 font-normal">
                                          <MuiSearchSelect
                                            placeholder={"commission"}
                                            label="commission"
                                            options={[]}
                                            onChange={function (
                                              value: string,
                                              id: string,
                                              data: any
                                            ): void {
                                              throw new Error(
                                                "Function not implemented."
                                              );
                                            }}
                                            value={""}
                                          />
                                        </td>

                                        <td className="text-gray-800 font-normal">
                                          <MuiSearchSelect
                                            placeholder={"commission"}
                                            label="commission"
                                            options={[]}
                                            onChange={function (
                                              value: string,
                                              id: string,
                                              data: any
                                            ): void {
                                              throw new Error(
                                                "Function not implemented."
                                              );
                                            }}
                                            value={""}
                                          />
                                        </td>
                                        <td className="text-gray-800 font-normal">
                                          <MuiSearchSelect
                                            placeholder={"commission"}
                                            label="commission"
                                            options={[]}
                                            onChange={function (
                                              value: string,
                                              id: string,
                                              data: any
                                            ): void {
                                              throw new Error(
                                                "Function not implemented."
                                              );
                                            }}
                                            value={""}
                                          />
                                        </td>
                                        <td className="text-gray-800 font-normal">
                                          <MuiSearchSelect
                                            placeholder={"commission"}
                                            label="commission"
                                            options={[]}
                                            onChange={function (
                                              value: string,
                                              id: string,
                                              data: any
                                            ): void {
                                              throw new Error(
                                                "Function not implemented."
                                              );
                                            }}
                                            value={""}
                                          />
                                        </td>
                                        <td className="text-gray-800 font-normal">
                                          <MuiSearchSelect
                                            placeholder={"commission"}
                                            label="commission"
                                            options={[]}
                                            onChange={function (
                                              value: string,
                                              id: string,
                                              data: any
                                            ): void {
                                              throw new Error(
                                                "Function not implemented."
                                              );
                                            }}
                                            value={""}
                                          />
                                        </td>
                                        <td className="text-gray-800 font-normal">
                                          <MuiSearchSelect
                                            placeholder={"commission"}
                                            label="commission"
                                            options={[]}
                                            onChange={function (
                                              value: string,
                                              id: string,
                                              data: any
                                            ): void {
                                              throw new Error(
                                                "Function not implemented."
                                              );
                                            }}
                                            value={""}
                                          />
                                        </td>
                                        <td className="text-gray-800 font-normal">
                                          <td className="text-gray-800 font-normal">
                                            <MuiSearchSelect
                                              placeholder={"commission"}
                                              label="commission"
                                              options={[]}
                                              onChange={function (
                                                value: string,
                                                id: string,
                                                data: any
                                              ): void {
                                                throw new Error(
                                                  "Function not implemented."
                                                );
                                              }}
                                              value={""}
                                            />
                                          </td>
                                        </td>
                                        <td className="text-gray-800 font-normal">
                                          <MuiSearchSelect
                                            placeholder={"commission"}
                                            label="commission"
                                            options={[]}
                                            onChange={function (
                                              value: string,
                                              id: string,
                                              data: any
                                            ): void {
                                              throw new Error(
                                                "Function not implemented."
                                              );
                                            }}
                                            value={""}
                                          />
                                        </td>
                                        <td className="text-gray-800 font-normal">
                                          <MuiSearchSelect
                                            placeholder={"commission"}
                                            label="commission"
                                            options={[]}
                                            onChange={function (
                                              value: string,
                                              id: string,
                                              data: any
                                            ): void {
                                              throw new Error(
                                                "Function not implemented."
                                              );
                                            }}
                                            value={""}
                                          />
                                        </td>
                                        <td className="text-gray-800 font-normal">
                                          <MuiSearchSelect
                                            placeholder={"commission"}
                                            label="commission"
                                            options={[]}
                                            onChange={function (
                                              value: string,
                                              id: string,
                                              data: any
                                            ): void {
                                              throw new Error(
                                                "Function not implemented."
                                              );
                                            }}
                                            value={""}
                                          />
                                        </td>
                                        <td className="text-gray-800 font-normal">
                                          <MuiSearchSelect
                                            placeholder={"commission"}
                                            label="commission"
                                            options={[]}
                                            onChange={function (
                                              value: string,
                                              id: string,
                                              data: any
                                            ): void {
                                              throw new Error(
                                                "Function not implemented."
                                              );
                                            }}
                                            value={""}
                                          />
                                        </td>
                                        <td className="text-gray-800 font-normal">
                                          <MuiSearchSelect
                                            placeholder={"commission"}
                                            label="commission"
                                            options={[]}
                                            onChange={function (
                                              value: string,
                                              id: string,
                                              data: any
                                            ): void {
                                              throw new Error(
                                                "Function not implemented."
                                              );
                                            }}
                                            value={""}
                                          />
                                        </td>
                                        <td className="text-gray-800 font-normal">
                                          <MuiSearchSelect
                                            placeholder={"commission"}
                                            label="commission"
                                            options={[]}
                                            onChange={function (
                                              value: string,
                                              id: string,
                                              data: any
                                            ): void {
                                              throw new Error(
                                                "Function not implemented."
                                              );
                                            }}
                                            value={""}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                           
                              </div>

                              <div className="user-button w-full mt-4 ">
                                <MuiButton
                                  className="main-btn get-btn"
                                  variant="contained"
                                  size="large"
                                  type="submit"
                                  label={"submit"}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ViewSupplierCommission;
